import {  useEffect } from "react";
import messagesHooksStore from "./hooks-store/configs/messagesHooksStore";
import Theme from "./_themes";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import authenticationStore from "./hooks-store/configs/authenticationStore";
import ProtectedRoutes from "./components_new/protected-route";
import { createBrowserHistory } from "history";
import { Login } from "./pages/login/login";
import { Home } from "./pages/home/home";
import imageRight from "../src/images/right-design.png"
import imageLeft from "../src/images/left-design.png"
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/app.sass";


messagesHooksStore();
authenticationStore();

const PatternImages = () => {
  return (
    <>
      <div className="image-container left-bottom">
        <img
          src={imageLeft}
          style={{
            position: "left", // or 'absolute' if needed
            // avoid inline issues
            width: "auto",
            height: "auto",
          }}
          alt="pattern"
        />
      </div>

      <div className="image-container right-bottom">
        <img
          src={imageRight}
          style={{
            position: "right", // or 'absolute' if needed
            // avoid inline issues
            width: "auto",
            height: "auto",
          }}
          alt="pattern"
        />
      </div>
    </>
  );
};



function App() {
  const history = createBrowserHistory();


  useEffect(() => {
    new Theme();
  }, []);

  return (
    <div className="powerbi-app">
      <Router
        history={history}
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
        
          <Route element={<ProtectedRoutes />}>
             
                               
            <Route index path="*" element={<Home />} />
          </Route>
          <Route path="login" element={<Login />}></Route>
          <Route path="*" element={<Page404 />} />
          
        </Routes>
      </Router>

      <PatternImages />
    </div>
  );
}

const Page404 = () => {
  <h1>404 not found!</h1>;
};

export default App;
